
export type Environment = 'development' | 'production'
export const ENVIRONMENT = process.env.NODE_ENV as Environment

export const BASE_URL = process.env.BASE_URL ?? 'http://localhost:3000'